export default {
  namespaced: true,
  state: {
    isHidden: true,
  },
  getters: {
    isSidebarHidden(state) {
      return state.isHidden;
    },
  },
  mutations: {
    SET_IS_HIDDEN(state, payload) {
      state.isHidden = payload;
    },
  },
  actions: {
    setSidebarHidden(context, payload) {
      context.commit('SET_IS_HIDDEN', payload);
    },
  },
};
